import { Card, Col, Form, Row } from 'react-bootstrap'
import Select from 'react-select'
import { cardStyle, labelDetailStyle } from './DcDetailStyles'

const DcSeriesInfo = ({
  detail,
  loadingSeriesNumber,
  seriesNumbers,
  selectedSeriesNumber,
  setSelectedSeriesNumber,
  seriesNumberRef,
  loadingDeliveryNote,
  deliveryNotes,
  selectedDeliveryNote,
  setSelectedDeliveryNote,
  deliveryNoteRef,
  loadingSalesInvoice,
  salesInvoices,
  selectedSalesInvoice,
  setSelectedSalesInvoice,
  salesInvoiceRef,
  handleChangeInput
}) => {
  return (
    <Card style={cardStyle}>
      <Row className="mb-3">
        <Col
          md={12}
          className="d-flex justify-content-between align-items-center"
        >
          <h5
            className="text-secondary mb-0"
            style={{ fontSize: '1rem', fontWeight: 'bold' }}
          >
            SERIES INFO
          </h5>
        </Col>
      </Row>
      <Row>
        <Col md={4}>
          <Form.Group>
            <Form.Label style={labelDetailStyle}>
              SERIES <sup style={{ color: 'red' }}>*</sup>
            </Form.Label>
            <Select
              isClearable
              isLoading={loadingSeriesNumber}
              id="series-number"
              isDisabled={detail?.erp_dc_no ? true : false}
              value={
                seriesNumbers?.find(
                  (opt) =>
                    opt.value ===
                    (detail?.series_number || selectedSeriesNumber)
                ) || null
              }
              onChange={(e) => {
                if (!e) {
                  e = {
                    value: '',
                    label: ''
                  }
                }
                setSelectedSeriesNumber(e?.value)
              }}
              options={seriesNumbers || []}
              onInputChange={(e, { action }) =>
                handleChangeInput(e, 'series_number', { action })
              }
              placeholder="Select Series Number"
              isSearchable
              ref={seriesNumberRef}
            />
          </Form.Group>
        </Col>
        <Col md={4}>
          <Form.Group>
            <Form.Label style={labelDetailStyle}>
              DELIVERY NOTES <sup style={{ color: 'red' }}>*</sup>
            </Form.Label>
            <Select
              isClearable
              isLoading={loadingDeliveryNote}
              id="series-delivery-note"
              isDisabled={detail?.erp_dc_no ? true : false}
              value={
                deliveryNotes?.find(
                  (opt) =>
                    opt.value ===
                    (detail?.series_delivery_note || selectedDeliveryNote)
                ) || null
              }
              onChange={(e) => {
                if (!e) {
                  e = {
                    value: '',
                    label: ''
                  }
                }
                setSelectedDeliveryNote(e?.value)
              }}
              options={deliveryNotes || []}
              onInputChange={(e, { action }) =>
                handleChangeInput(e, 'series_delivery_note', {
                  action
                })
              }
              placeholder="Select Series Delivery Note"
              isSearchable
              ref={deliveryNoteRef}
            />
          </Form.Group>
        </Col>
        <Col md={4}>
          <Form.Group>
            <Form.Label style={labelDetailStyle}>
              SALES INVOICE <sup style={{ color: 'red' }}>*</sup>
            </Form.Label>
            <Select
              isClearable
              isLoading={loadingSalesInvoice}
              id="series-sales-invoice"
              value={
                salesInvoices?.find(
                  (opt) =>
                    opt.value ===
                    (detail?.series_sales_invoice || selectedSalesInvoice)
                ) || null
              }
              isDisabled={detail?.erp_dc_no ? true : false}
              onChange={(e) => {
                if (!e) {
                  e = {
                    value: '',
                    label: ''
                  }
                }
                setSelectedSalesInvoice(e?.value)
              }}
              options={salesInvoices || []}
              onInputChange={(e, { action }) =>
                handleChangeInput(e, 'series_sales_invoice', {
                  action
                })
              }
              placeholder="Select Sales Invoice"
              isSearchable
              ref={salesInvoiceRef}
            />
          </Form.Group>
        </Col>
      </Row>
    </Card>
  )
}

export default DcSeriesInfo
